<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { ShortcutsDefinition } from 'header/types';

    interface Props {
        field: ShortcutsDefinition;
    }

    let { field }: Props = $props();

    const dispatch = createEventDispatcher();

    let leftValues = $derived(field.value.left);
    let centerValues = $derived(field.value.center);
    let rightValues = $derived(field.value.right);

    const updateLabelLeft = (e: { currentTarget: HTMLInputElement }, index: number) => {
        dispatch('change', {
            field: {
                ...field,
                value: {
                    ...field.value,
                    left: field.value.left.map((val, idx) => ({
                        ...val,
                        label: idx !== index ? val.label : e.currentTarget.value,
                    })),
                },
            },
        });
    };

    const updateLabelCenter = (e: { currentTarget: HTMLInputElement }, index: number) => {
        dispatch('change', {
            field: {
                ...field,
                value: {
                    ...field.value,
                    center: field.value.center.map((val, idx) => ({
                        ...val,
                        label: idx !== index ? val.label : e.currentTarget.value,
                    })),
                },
            },
        });
    };

    const updateLabelRight = (e: { currentTarget: HTMLInputElement }, index: number) => {
        dispatch('change', {
            field: {
                ...field,
                value: {
                    ...field.value,
                    right: field.value.right.map((val, idx) => ({
                        ...val,
                        label: idx !== index ? val.label : e.currentTarget.value,
                    })),
                },
            },
        });
    };
</script>

<div class="row">
    <span class="row-name">Left: </span>
    <div class="labels">
        {#each leftValues as value, idx}
            <div class="label">
                <span>{value.key} = {value.value}</span>
                <input
                    size={value.label.length}
                    value={value.label}
                    onchange={e => updateLabelLeft(e, idx)}
                />
            </div>
        {/each}
    </div>
</div>
<div class="row">
    <span class="row-name">Center: </span>
    <div class="labels">
        {#each centerValues as value, idx}
            <div class="label">
                <span>{value.key} = {value.value}</span>
                <input
                    size={value.label.length}
                    value={value.label}
                    onchange={e => updateLabelCenter(e, idx)}
                />
            </div>
        {/each}
    </div>
</div>
<div class="row">
    <span class="row-name">Right: </span>
    <div class="labels">
        {#each rightValues as value, idx}
            <div class="label">
                <span>{value.key} = {value.value}</span>
                <input
                    size={value.label.length}
                    value={value.label}
                    onchange={e => updateLabelRight(e, idx)}
                />
            </div>
        {/each}
    </div>
</div>

<style lang="scss" scoped>
    .row {
        font-size: 0.7rem;

        .labels {
            background-color: #eee;
            padding: 1px;
            min-height: 24px;

            .label {
                border: 1px solid silver;
                border-radius: 8px;
                padding: 0 6px;
                margin: 1px;
                background-color: #fff;
                display: inline-block;

                span {
                    font-size: 0.9em;
                }

                input {
                    font-family: monospace;
                    border: none;
                }
            }
        }
    }
</style>
